import { jsx as _jsx } from "react/jsx-runtime";
import { ManualDataRecordModalForm, Modal, usePregnancy } from "@madmedical/ui";
import { ApiFormWrapper } from "@madmedical/form";
import { usePatientId } from "@madmedical/user";
import { MetricType } from "@madmedical/medical";
import { useCreateManualMutation } from "../../measurement/api";
const PregnancyMeasurementModalForm = ({ metricType, open, onClose, }) => {
    const { patientId } = usePatientId();
    const [createManual] = useCreateManualMutation();
    const { refetchBMI } = usePregnancy();
    return (_jsx(Modal, Object.assign({ open: open, onClose: onClose, size: "xs" }, { children: _jsx(ApiFormWrapper, Object.assign({ defaultValues: {
                userId: patientId,
                measuredAt: new Date().toISOString(),
                metric: { type: metricType },
            }, mutation: createManual, resetOnSuccess: true, onSuccess: metricType === MetricType.BodyWeight
                ? () => {
                    setTimeout(() => {
                        refetchBMI === null || refetchBMI === void 0 ? void 0 : refetchBMI();
                    }, 3000);
                }
                : undefined }, { children: ({ submitForm, isSuccess }) => (_jsx(ManualDataRecordModalForm, { metricType: metricType, onClose: onClose, onSubmitPress: submitForm, isSuccess: isSuccess })) })) })));
};
export default PregnancyMeasurementModalForm;
